import React, { type ReactChildren, type ReactElement } from 'react';

import * as D from '../deps';

import './BackstageHeroSidebarImage.scss';

export interface IBackstageHeroSidebarImageOwnProps {
  children: ReactChildren | ReactElement;
  heroImageIsCircle: boolean;
  isRightRailActive: boolean;
  isCuratorExperienceEnabled: boolean;
  renderArtworkPlayButton: boolean;
}

export type IBackstageHeroSidebarImageProps = IBackstageHeroSidebarImageOwnProps;

export const BackstageHeroSidebarImage: React.FC<IBackstageHeroSidebarImageProps> = props => {
  const {
    children,
    heroImageIsCircle,
    renderArtworkPlayButton,
    isRightRailActive,
    isCuratorExperienceEnabled,
  } = props;

  const imageClasses = D.createBEM('BackstageHeroSidebarImage', {
    circle: heroImageIsCircle,
    curatorExperienceEnabled: isCuratorExperienceEnabled,
    renderArtworkPlayButton: renderArtworkPlayButton && !heroImageIsCircle,
    rightRail: isRightRailActive,
  });

  return <div className={imageClasses}>{children}</div>;
};

export default BackstageHeroSidebarImage;
